import VerticalDivider from '@/global/components/Divider/VerticalDivider'
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from '@/global/components/ui/tabs'
import { PlanoFixo } from '@/service/api'
import ContentGuide from 'global/guides/ContentGuide'
import { usePlanosContext } from 'pages/Planos.context'
import React, { useMemo, useState } from 'react'
import { PlanosCard } from './components/PlanosCard'

type TipoPlanos = 'mensal' | 'trimestral' | 'anual'

type Data = {
    mensal: PlanoFixo[]
    anual: PlanoFixo[]
    trimestral: PlanoFixo[]
}

const STATUS_ATIVOS_PENDENTES = ['active', 'waitingPayment']

export const Planos: React.FC = () => {
    const { planos, assinatura, PlanoDiferenciado } = usePlanosContext()
    const [value, setValue] = useState<TipoPlanos>('mensal')

    const { anual, mensal, trimestral } = useMemo<Data>(() => {
        if (planos) {
            return {
                anual: planos.filter(plano => plano.periodicity === 'yearly'),
                mensal: planos.filter(plano => plano.periodicity === 'monthly'),
                trimestral: planos.filter(
                    plano => plano.periodicity === 'quarterly',
                ),
            }
        }

        return { mensal: [], anual: [], trimestral: [] }
    }, [planos])

    const handleChange = (newValue: string) => {
        setValue(newValue as TipoPlanos)
    }

    if (PlanoDiferenciado)
        return (
            <ContentGuide>
                <PlanosCard
                    planos={[
                        {
                            id: 0,
                            limiteFuncionarios: 0,
                            periodicity: PlanoDiferenciado.periodicidade,
                            price: PlanoDiferenciado.valorCentavos,
                        },
                    ]}
                    trocar={STATUS_ATIVOS_PENDENTES.includes(
                        assinatura?.status || '',
                    )}
                />
            </ContentGuide>
        )

    return (
        <Tabs value={value} onValueChange={handleChange} className="contents">
            <div className="flex flex-col rounded-md px-0 sm:px-4 md:px-8 h-[calc(100vh-5rem)] overflow-hidden container mx-auto">
                <div className="border-b w-full md:pt-4 h-fit">
                    <TabsList
                        aria-label="Todos os planos"
                        className="rounded-b-none"
                    >
                        <TabsTrigger value="mensal">Planos mensais</TabsTrigger>
                        <VerticalDivider className="my-2" />
                        <TabsTrigger value="trimestral">
                            Planos trimestrais
                        </TabsTrigger>
                        <VerticalDivider className="my-2" />
                        <TabsTrigger value="anual">Planos anuais</TabsTrigger>
                    </TabsList>
                </div>
                <div className="overflow-y-auto overflow-x-hidden flex-1 bg-card/35 rounded-b-md">
                    <TabsContent
                        value="mensal"
                        className="p-1 md:p-4 max-h-full mt-0"
                    >
                        <PlanosCard
                            planos={mensal}
                            trocar={STATUS_ATIVOS_PENDENTES.includes(
                                assinatura?.status || '',
                            )}
                        />
                    </TabsContent>
                    <TabsContent
                        value="trimestral"
                        className="p-1 md:p-4 max-h-full mt-0"
                    >
                        <PlanosCard
                            planos={trimestral}
                            trocar={STATUS_ATIVOS_PENDENTES.includes(
                                assinatura?.status || '',
                            )}
                        />
                    </TabsContent>
                    <TabsContent
                        value="anual"
                        className="p-1 md:p-4 max-h-full mt-0"
                    >
                        <PlanosCard
                            planos={anual}
                            trocar={STATUS_ATIVOS_PENDENTES.includes(
                                assinatura?.status || '',
                            )}
                        />
                    </TabsContent>
                </div>
            </div>
        </Tabs>
    )
}
